/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { LeadAdmissionFlagsInnerAdmissionFlag } from './LeadAdmissionFlagsInnerAdmissionFlag';
import {
    LeadAdmissionFlagsInnerAdmissionFlagFromJSON,
    LeadAdmissionFlagsInnerAdmissionFlagFromJSONTyped,
    LeadAdmissionFlagsInnerAdmissionFlagToJSON,
} from './LeadAdmissionFlagsInnerAdmissionFlag';

/**
 * 
 * @export
 * @interface LeadAdmissionFlagsInner
 */
export interface LeadAdmissionFlagsInner {
    /**
     * 
     * @type {string}
     * @memberof LeadAdmissionFlagsInner
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof LeadAdmissionFlagsInner
     */
    lead_id?: string;
    /**
     * 
     * @type {string}
     * @memberof LeadAdmissionFlagsInner
     */
    flag_id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof LeadAdmissionFlagsInner
     */
    is_dismissed?: boolean;
    /**
     * 
     * @type {LeadAdmissionFlagsInnerAdmissionFlag}
     * @memberof LeadAdmissionFlagsInner
     */
    admission_flag?: LeadAdmissionFlagsInnerAdmissionFlag;
}

/**
 * Check if a given object implements the LeadAdmissionFlagsInner interface.
 */
export function instanceOfLeadAdmissionFlagsInner(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function LeadAdmissionFlagsInnerFromJSON(json: any): LeadAdmissionFlagsInner {
    return LeadAdmissionFlagsInnerFromJSONTyped(json, false);
}

export function LeadAdmissionFlagsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeadAdmissionFlagsInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'lead_id': !exists(json, 'lead_id') ? undefined : json['lead_id'],
        'flag_id': !exists(json, 'flag_id') ? undefined : json['flag_id'],
        'is_dismissed': !exists(json, 'is_dismissed') ? undefined : json['is_dismissed'],
        'admission_flag': !exists(json, 'admission_flag') ? undefined : LeadAdmissionFlagsInnerAdmissionFlagFromJSON(json['admission_flag']),
    };
}

export function LeadAdmissionFlagsInnerToJSON(value?: LeadAdmissionFlagsInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'lead_id': value.lead_id,
        'flag_id': value.flag_id,
        'is_dismissed': value.is_dismissed,
        'admission_flag': LeadAdmissionFlagsInnerAdmissionFlagToJSON(value.admission_flag),
    };
}

